import React, { useState } from 'react';
import { motion } from 'framer-motion';

const ServicesPage = () => {
  const [activeCategory, setActiveCategory] = useState('todos');
  
  const serviceCategories = [
    {
      id: 'todos',
      name: 'Todos los Servicios',
      count: 18
    },
    {
      id: 'ingenieria',
      name: 'Ingeniería',
      count: 5
    },
    {
      id: 'industrial',
      name: 'Industrial',
      count: 6
    },
    {
      id: 'construccion',
      name: 'Construcción',
      count: 4
    },
    {
      id: 'consultoria',
      name: 'Consultoría',
      count: 3
    }
  ];
  
  const services = [
    // Ingeniería services
    {
      id: 'diseno-ingenieria',
      title: 'Diseño e Ingeniería',
      category: 'ingenieria',
      description: 'Elaboración de planos técnicos y de construcción, modelado en 3D y renderización de proyectos, análisis estructural mediante software especializado, ingeniería de valor para optimizar costos y recursos, diseño CAD/BIM avanzado para proyectos complejos.',
      details: [
        'Elaboración de planos técnicos y de construcción',
        'Modelado en 3D y renderización de proyectos',
        'Análisis estructural mediante software especializado',
        'Ingeniería de valor para optimizar costos y recursos',
        'Diseño CAD/BIM avanzado para proyectos complejos'
      ],
      icon: '⚙️' // PLACEHOLDER: Add actual icon
    },
    {
      id: 'analisis-estructural',
      title: 'Análisis Estructural',
      category: 'ingenieria',
      description: 'Evaluación y análisis de estructuras existentes, simulaciones de carga y resistencia, recomendaciones de refuerzo o modificación, estudios geotécnicos y de suelos, cálculos sísmicos y de estabilidad.',
      details: [
        'Evaluación y análisis de estructuras existentes',
        'Simulaciones de carga y resistencia',
        'Recomendaciones de refuerzo o modificación',
        'Estudios geotécnicos y de suelos',
        'Cálculos sísmicos y de estabilidad'
      ],
      icon: '🏢' // PLACEHOLDER: Add actual icon
    },
    {
      id: 'supervision-obras',
      title: 'Supervisión de Obras',
      category: 'ingenieria',
      description: 'Control de calidad en procesos constructivos, supervisión de instalaciones mecánicas y eléctricas, verificación de cumplimiento de planos y especificaciones, seguimiento de cronogramas y hitos, coordinación de actividades multidisciplinarias.',
      details: [
        'Control de calidad en procesos constructivos',
        'Supervisión de instalaciones mecánicas y eléctricas',
        'Verificación de cumplimiento de planos y especificaciones',
        'Seguimiento de cronogramas y hitos',
        'Coordinación de actividades multidisciplinarias'
      ],
      icon: '📋' // PLACEHOLDER: Add actual icon
    },
    {
      id: 'gestion-proyectos',
      title: 'Gestión de Proyectos',
      category: 'ingenieria',
      description: 'Planificación y control de cronogramas, gestión de recursos humanos y materiales, coordinación de actividades multidisciplinarias, control de calidad y seguridad en obra, supervisión de instalaciones mecánicas y eléctricas.',
      details: [
        'Planificación y control de cronogramas',
        'Gestión de recursos humanos y materiales',
        'Coordinación de actividades multidisciplinarias',
        'Control de calidad y seguridad en obra',
        'Supervisión de instalaciones mecánicas y eléctricas'
      ],
      icon: '📊' // PLACEHOLDER: Add actual icon
    },
    {
      id: 'asesoria-tecnica',
      title: 'Asesoría Técnica',
      category: 'ingenieria',
      description: 'Evaluación de factibilidad técnica y económica de proyectos, asesoramiento técnico en la selección de materiales, consultoría en normativas y regulaciones de construcción, apoyo en la planificación y gestión de proyectos, soporte técnico durante todas las etapas del proyecto.',
      details: [
        'Evaluación de factibilidad técnica y económica de proyectos',
        'Asesoramiento técnico en la selección de materiales',
        'Consultoría en normativas y regulaciones de construcción',
        'Apoyo en la planificación y gestión de proyectos',
        'Soporte técnico durante todas las etapas del proyecto'
      ],
      icon: '💡' // PLACEHOLDER: Add actual icon
    },
    
    // Industrial services
    {
      id: 'fabricacion-metalica',
      title: 'Fabricación Metálica',
      category: 'industrial',
      description: 'Fabricación de estructuras metálicas personalizadas, soldadura especializada y corte térmico, control de calidad en procesos de fabricación, diseño y fabricación de maquinaria industrial, producción de componentes mecánicos bajo especificaciones.',
      details: [
        'Fabricación de estructuras metálicas personalizadas',
        'Soldadura especializada y corte térmico',
        'Control de calidad en procesos de fabricación',
        'Diseño y fabricación de maquinaria industrial',
        'Producción de componentes mecánicos bajo especificaciones'
      ],
      icon: '🏭' // PLACEHOLDER: Add actual icon
    },
    {
      id: 'montaje-industrial',
      title: 'Montaje Industrial',
      category: 'industrial',
      description: 'Montaje de equipos industriales y maquinaria, instalación de líneas de producción, conexión de sistemas mecánicos y eléctricos, puesta en marcha de instalaciones industriales, comisionamiento de equipos.',
      details: [
        'Montaje de equipos industriales y maquinaria',
        'Instalación de líneas de producción',
        'Conexión de sistemas mecánicos y eléctricos',
        'Puesta en marcha de instalaciones industriales',
        'Comisionamiento de equipos'
      ],
      icon: '⚙️' // PLACEHOLDER: Add actual icon
    },
    {
      id: 'mantenimiento-industrial',
      title: 'Mantenimiento Industrial',
      category: 'industrial',
      description: 'Programas de mantenimiento preventivo y correctivo, inspección y evaluación de equipos industriales, reparación y modernización de maquinaria, servicios de calibración y ajuste, soporte técnico post-instalación.',
      details: [
        'Programas de mantenimiento preventivo y correctivo',
        'Inspección y evaluación de equipos industriales',
        'Reparación y modernización de maquinaria',
        'Servicios de calibración y ajuste',
        'Soporte técnico post-instalación'
      ],
      icon: '🔧' // PLACEHOLDER: Add actual icon
    },
    {
      id: 'automatizacion',
      title: 'Automatización Industrial',
      category: 'industrial',
      description: 'Diseño e implementación de sistemas automatizados, integración de tecnologías de control, programación de PLCs y sistemas SCADA, instalación de sensores y actuadores, desarrollo de interfaces hombre-máquina (HMI).',
      details: [
        'Diseño e implementación de sistemas automatizados',
        'Integración de tecnologías de control',
        'Programación de PLCs y sistemas SCADA',
        'Instalación de sensores y actuadores',
        'Desarrollo de interfaces hombre-máquina (HMI)'
      ],
      icon: '🤖' // PLACEHOLDER: Add actual icon
    },
    {
      id: 'seguridad-industrial',
      title: 'Seguridad Industrial',
      category: 'industrial',
      description: 'Evaluación de riesgos industriales, implementación de sistemas de seguridad, auditorías de seguridad en instalaciones, capacitación en seguridad industrial, desarrollo de procedimientos de emergencia.',
      details: [
        'Evaluación de riesgos industriales',
        'Implementación de sistemas de seguridad',
        'Auditorías de seguridad en instalaciones',
        'Capacitación en seguridad industrial',
        'Desarrollo de procedimientos de emergencia'
      ],
      icon: '🛡️' // PLACEHOLDER: Add actual icon
    },
    {
      id: 'control-calidad',
      title: 'Control de Calidad',
      category: 'industrial',
      description: 'Inspección de materiales y componentes, pruebas no destructivas, verificación de tolerancias dimensionales, análisis de propiedades mecánicas, certificación de calidad de productos.',
      details: [
        'Inspección de materiales y componentes',
        'Pruebas no destructivas',
        'Verificación de tolerancias dimensionales',
        'Análisis de propiedades mecánicas',
        'Certificación de calidad de productos'
      ],
      icon: '✅' // PLACEHOLDER: Add actual icon
    },
    
    // Construcción services
    {
      id: 'obras-civiles',
      title: 'Obras Civiles',
      category: 'construccion',
      description: 'Construcción de edificios industriales y comerciales, obras de infraestructura civil, construcción de plantas industriales, proyectos de urbanización y saneamiento, construcción de centros de distribución.',
      details: [
        'Construcción de edificios industriales y comerciales',
        'Obras de infraestructura civil',
        'Construcción de plantas industriales',
        'Proyectos de urbanización y saneamiento',
        'Construcción de centros de distribución'
      ],
      icon: '🏗️' // PLACEHOLDER: Add actual icon
    },
    {
      id: 'estructuras-metalicas',
      title: 'Estructuras Metálicas',
      category: 'construccion',
      description: 'Diseño y fabricación de estructuras metálicas para edificaciones, montaje de estructuras de acero, conexiones especiales y detalles estructurales, tratamiento anticorrosivo y acabados, inspección de calidad de estructuras.',
      details: [
        'Diseño y fabricación de estructuras metálicas para edificaciones',
        'Montaje de estructuras de acero',
        'Conexiones especiales y detalles estructurales',
        'Tratamiento anticorrosivo y acabados',
        'Inspección de calidad de estructuras'
      ],
      icon: '🔩' // PLACEHOLDER: Add actual icon
    },
    {
      id: 'instalaciones-especiales',
      title: 'Instalaciones Especiales',
      category: 'construccion',
      description: 'Instalaciones eléctricas industriales, sistemas de climatización y ventilación, redes de agua y saneamiento, sistemas contra incendios, instalaciones de telecomunicaciones.',
      details: [
        'Instalaciones eléctricas industriales',
        'Sistemas de climatización y ventilación',
        'Redes de agua y saneamiento',
        'Sistemas contra incendios',
        'Instalaciones de telecomunicaciones'
      ],
      icon: '🔌' // PLACEHOLDER: Add actual icon
    },
    
    // Consultoría services
    {
      id: 'consultoria-ingenieria',
      title: 'Consultoría de Ingeniería',
      category: 'consultoria',
      description: 'Asesoramiento técnico en proyectos de ingeniería, evaluación de alternativas de diseño, análisis de costos y presupuestos, seguimiento y control de proyectos, asistencia en procesos de licitación.',
      details: [
        'Asesoramiento técnico en proyectos de ingeniería',
        'Evaluación de alternativas de diseño',
        'Análisis de costos y presupuestos',
        'Seguimiento y control de proyectos',
        'Asistencia en procesos de licitación'
      ],
      icon: '👨‍💼' // PLACEHOLDER: Add actual icon
    },
    {
      id: 'evaluacion-proyectos',
      title: 'Evaluación de Proyectos',
      category: 'consultoria',
      description: 'Análisis de viabilidad técnica y económica, estudios de impacto ambiental, evaluación de riesgos y mitigación, análisis de mercado y demanda, desarrollo de estrategias de implementación.',
      details: [
        'Análisis de viabilidad técnica y económica',
        'Estudios de impacto ambiental',
        'Evaluación de riesgos y mitigación',
        'Análisis de mercado y demanda',
        'Desarrollo de estrategias de implementación'
      ],
      icon: '🔍' // PLACEHOLDER: Add actual icon
    },
    {
      id: 'normativas-legales',
      title: 'Normativas y Legales',
      category: 'consultoria',
      description: 'Asesoría en normativas de construcción, cumplimiento de regulaciones locales y nacionales, permisos y autorizaciones, estudios de impacto regulatorio, soporte en procesos de certificación.',
      details: [
        'Asesoría en normativas de construcción',
        'Cumplimiento de regulaciones locales y nacionales',
        'Permisos y autorizaciones',
        'Estudios de impacto regulatorio',
        'Soporte en procesos de certificación'
      ],
      icon: '⚖️' // PLACEHOLDER: Add actual icon
    }
  ];

  const filteredServices = activeCategory === 'todos' 
    ? services 
    : services.filter(service => service.category === activeCategory);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-12 page-top-spacing">
      <div className="container-standard px-4">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-3xl md:text-4xl font-bold text-primary-dark mb-4">Nuestros Servicios</h1>
          <div className="w-20 h-1 bg-primary-accent mx-auto"></div>
          <p className="mt-6 text-base text-gray-600 max-w-3xl mx-auto">
            Ofrecemos soluciones integrales en ingeniería, industrial y construcción con enfoque en la excelencia técnica y la seguridad.
          </p>
        </motion.div>

        {/* Service Categories */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {serviceCategories.map((category) => (
            <motion.button
              key={category.id}
              className={`px-6 py-3 rounded-full font-medium transition-all duration-300 ${
                activeCategory === category.id
                  ? 'bg-primary-dark text-white shadow-lg'
                  : 'bg-white text-primary-dark hover:bg-gray-100 border border-gray-200'
              }`}
              onClick={() => setActiveCategory(category.id)}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {category.name} 
              <span className={`ml-2 px-2 py-1 rounded-full text-xs ${
                activeCategory === category.id
                  ? 'bg-white bg-opacity-20'
                  : 'bg-primary-accent bg-opacity-20'
              }`}>
                {category.count}
              </span>
            </motion.button>
          ))}
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredServices.map((service, index) => (
            <motion.div
              key={service.id}
              className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100 card-elevated"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -10, boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)' }}
            >
              <div className="p-8">
                <div className="flex justify-center mb-6">
                  <div className="w-20 h-20 bg-primary-accent bg-opacity-10 rounded-full flex items-center justify-center text-4xl">
                    {service.icon}
                  </div>
                </div>
                
                <h3 className="text-xl font-bold text-center text-primary-dark mb-4">{service.title}</h3>
                
                <p className="text-gray-600 mb-6 text-center">{service.description}</p>
                
                <div className="space-y-3">
                  <h4 className="font-semibold text-primary-accent">Detalles del servicio:</h4>
                  <ul className="space-y-2">
                    {service.details.map((detail, idx) => (
                      <li 
                        key={idx} 
                        className="flex items-start text-gray-700 text-sm"
                      >
                        <span className="text-primary-accent mr-2 mt-1 flex-shrink-0">✓</span>
                        <span>{detail}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              
              <div className="bg-gradient-to-r from-primary-dark to-primary-accent h-1 w-full"></div>
            </motion.div>
          ))}
        </div>

        {/* Call to Action */}
        <motion.div 
          className="mt-16 bg-gradient-to-r from-primary-dark to-primary-accent rounded-2xl shadow-xl p-12 text-white text-center"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <h2 className="text-heading font-bold mb-4">¿Necesitas una solución personalizada?</h2>
          <p className="text-body-lg mb-8 max-w-2xl mx-auto">
            Nuestro equipo de expertos está listo para ayudarte a desarrollar la solución perfecta para tus necesidades industriales y de ingeniería.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <motion.button
              className="bg-white text-primary-dark font-bold py-4 px-8 rounded-lg hover:bg-gray-100 transition duration-300"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Contáctanos
            </motion.button>
            <motion.button
              className="bg-transparent border-2 border-white text-white font-bold py-4 px-8 rounded-lg hover:bg-white hover:text-primary-dark transition duration-300"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Solicitar cotización
            </motion.button>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default ServicesPage;